import { render, staticRenderFns } from "./myQuest.vue?vue&type=template&id=15178ec2&scoped=true&"
import script from "./myQuest.vue?vue&type=script&lang=js&"
export * from "./myQuest.vue?vue&type=script&lang=js&"
import style0 from "./myQuest.vue?vue&type=style&index=0&id=15178ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15178ec2",
  null
  
)

export default component.exports